import React from 'react';
import { Autocomplete, TextField, InputAdornment } from '@mui/material';

const CustomAutocomplete = React.forwardRef(
  ({
    options,
    value,
    onChange,
    disabled,
    error,
    helperText,
    onKeyDown,
    id,
    name,
    label,
    InputProps = {},
    endAdornment,
    className,
    variant = "outlined",
  }, ref) => {
    return (
      <Autocomplete
        id={id}
        options={options}
        getOptionLabel={(option) => option.Name || ''}
        value={value}
        onChange={(event, newValue) => {
          const syntheticEvent = {
            target: {
              name: name,
              value: newValue ? newValue.Id : '',
              option: newValue,
            },
          };
          onChange(syntheticEvent);
        }}
        popupIcon={undefined}
        clearOnBlur={false}
        renderInput={(params) => (
          <TextField
            {...params}
            name={name}
            label={label}
            variant={variant}
            size="small"
            error={!!error}
            helperText={helperText}
            inputRef={ref}
            onKeyDown={onKeyDown}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <>
                  {params.InputProps.startAdornment}
                </>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  {endAdornment}
                  {params.InputProps.endAdornment}
                </InputAdornment>
              ),
            }}
            fullWidth
            className={className}
          />
        )}
        disabled={disabled}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: 1,
            backgroundColor: disabled ? '#fff' : 'background.paper',
          },
          "& .MuiOutlinedInput-root.Mui-disabled": {
            color: 'rgba(0, 0, 0, 0.87)',
            WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)',
            backgroundColor: '#fff',
          },
          "& .MuiAutocomplete-inputRoot.Mui-disabled": {
            color: 'rgba(0, 0, 0, 0.87)',
            WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)',
          }
        }}
        isOptionEqualToValue={(option, value) => option.Id === value.Id}
      />
    );
  }
);

export default CustomAutocomplete;
